export const EXCLUDED_MODALS_FROM_PERSISTENT = [
  'order.status',
  'orders.cancel',
  'account.totp',
  'account.password',
  'proxies.admin.events',
  'proxies.admin.diagnostic',
  'credit.card.remove',
  'proxies.whitelist.global',
];
